/*
This hook will be run to initialize any necessary data for the authenticated user
prior to the routes being loaded.  

This is useful for loading user-specific data that is required for the application to function properly.
*/

import { useUserStore } from '@/stores/user.store';

export default async (to) => {
  console.log('Initializing...');
  // if route isn't authenticated, next
  if (!to.meta?.authenticated) return true;

  // if user has a session, initialize user
  const userStore = useUserStore();
  if (userStore.hasSession) {
    try {
      // we can fetch data we need for the user here
      await userStore.fetchUser();
      // await user.initialize();
    } catch (error) {
      console.error('Error during initializing', error);
      throw error;
    }
  } else {
    console.error('Error during initializing', 'No session available');
    throw new Error('No session available');
  }

  // always return true
  return true;
};
